export const templates = (state) => {
  return state.templates;
};
export const loading = (state) => {
  return state.loading;
};
